"use strict";

// https://codepen.io/AurelienZMN/pen/WvVaQj
angular.module("core")
.directive("onlyNumbersAndDecimalPointInput", function() {
    return {
        require: 'ngModel',
        link: function(scope, element, attr, ngModelCtrl) {
            var decimalPlaces = attr.decimalPlaces || 3;

            function fromUser(text) {
                var transformedInput = text.replace(/[^0-9,.]/g, '').replace(",", ".");
                var firstChar = transformedInput.charAt(0);
                var secondChar = transformedInput.charAt(1);
                if (firstChar === '.') {
                    transformedInput = '0.';
                }
                if (firstChar === '0' && secondChar === '0') {
                    transformedInput = '0';
                }
                if (transformedInput.length > 1 && firstChar === '0' && secondChar !== '.') {
                    transformedInput = transformedInput.substring(1);
                }

                var fractional = transformedInput.split('.')[1];

                if (fractional !== undefined && fractional.length > 0) {
                    var lastChar = transformedInput.substring(transformedInput.length - 1);
                    if (lastChar === '.') {
                        transformedInput = transformedInput.slice(0, -1);
                    }
                    if (fractional.length > decimalPlaces) {
                        transformedInput = transformedInput.slice(0, -1);
                    }
                }
                var twoLastChar = transformedInput.substring(transformedInput.length - 2);

                if (twoLastChar === '..') {
                    transformedInput = transformedInput.slice(0, -1);
                }

                if (transformedInput !== text) {
                    ngModelCtrl.$setViewValue(transformedInput);
                    ngModelCtrl.$render();
                }
                return transformedInput;

            }

            ngModelCtrl.$parsers.push(fromUser);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/only-numbers-and-decimal-point-input/only-numbers-and-decimal-point-input.directive.js
// module id = 486
// module chunks = 0